module.exports = __webpack_public_path__ + "files/5b74f89005108342d72850afb0374a68.png";